import { makeStyles, Theme } from '@material-ui/core/styles';
import { darkBlue } from '@signaturit/react-components-library';

type UseCollapsibleMenuStylesProps = {
    collapsed: boolean;
    isTrialActive: boolean;
    permanent: boolean;
    isDesktop: boolean;
    iconVisibility: boolean;
};

const pixelLineColor = '#D7DFE9';

const getPaperClasses = ({ isTrialActive, collapsed, permanent }: UseCollapsibleMenuStylesProps) => {
    if (isTrialActive) {
        return {
            paddingTop: 56,
            display: 'block !important',
            width: !collapsed || permanent ? 256 : 0,
            padding: !collapsed ? '16px' : 0,
            height: '100%',
            overflow: 'hidden',
            zIndex: 102,
            border: 'none',

            '@media (max-width: 768px)': {
                paddingTop: 110,
            },
            '@media (max-width: 480px)': {
                paddingTop: 165,
            },
        };
    }
    return {
        display: 'block !important',
        width: !collapsed || permanent ? 256 : 0,
        padding: !collapsed ? '16px' : 0,
        height: '100%',
        overflow: 'hidden',
        zIndex: 102,
        border: 'none',
    };
};

export const useCollapsibleMenuStyles = makeStyles<Theme, UseCollapsibleMenuStylesProps>((theme) => ({
    nonCollapsedSpace: {
        width: 24,
    },

    nonCollapsedBackdrop: ({ isDesktop }) => ({
        backgroundColor: isDesktop ? 'transparent' : darkBlue,
        opacity: '0.8 !important',
        transition: 'opacity 225ms cubic-bezier(0.4, 0, 0.2, 0.8) 0ms !important',
    }),

    paper: getPaperClasses,

    collapsibleMenuContainer: ({ permanent, isDesktop }) => {
        let width: number = isDesktop ? 28 : 0;

        if (permanent) {
            if (isDesktop) {
                width = 268;
            } else {
                width = 256;
            }
        }

        return {
            height: '100%',
            width,
        };
    },

    collapsibleDrawer: {
        height: '100%',
        display: 'flex',
    },

    menuToggle: ({ collapsed, permanent, iconVisibility }) => ({
        position: 'fixed',
        height: '100%',
        cursor: 'pointer',
        display: 'flex',
        visibility: iconVisibility ? 'visible' : 'hidden',
        justifyItems: 'center',
        alignItems: 'center',
        zIndex: theme.zIndex.snackbar,
        transform: !collapsed || permanent ? 'translateX(228px)' : 'none',
        backgroundImage: collapsed ? `linear-gradient(${pixelLineColor}, ${pixelLineColor})` : 'none',
        backgroundSize: '1px 100%',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
    }),

    toggleButton: ({ collapsed }) => ({
        marginLeft: collapsed ? 4 : 0,
        height: 40,
        borderRadius: 4,
        border: '1px solid #92ADCC',
        background: 'white',

        '&:hover': {
            background: 'white',
        },
    }),

    children: ({ collapsed, permanent }) => ({
        display: !collapsed || permanent ? 'block' : 'none',
    }),

    toggleCollapseIcon: ({ permanent, collapsed }) => ({
        fontSize: 16,
        transform: permanent ? 'rotate(180deg)' : 'none',
    }),
}));
